import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "@/store/store";
import LoginPage from "@/views/LoginPage";
import RegistrationPage from "@/views/RegistrationPage";
import RegistrationPaymentPage from "@/views/RegistrationPaymentPage";
import ConfirmAccount from "@/components/Authentication/ConfirmAccount";
import ForgotPasswordPage from "@/views/ForgotPasswordPage";
import ResetPasswordPage from "@/views/ResetPasswordPage";
import CirclesPage from "@/views/CirclesPage";
import CircleEdit from "@/components/Circles/CircleEdit";
import MyCircles from "@/components/Circles/MyCircles";
import AcceptOrganizationInvitation from "@/components/Authentication/AcceptOrganizationInvitation";
import CircleAddMembers from "@/components/Circles/CircleAddMembers";
import NotificationSender from "@/components/Notification/NotificationSender";
import NotificationBasic from "@/components/Notification/NotificationBasic";
import NotificationHistory from "@/components/Notification/NotificationHistory";
import CircleMap from "@/components/Circles/CircleMap";
import MyAccount from "@/components/Account/MyAccount";
import OrganizationSettings from "@/components/Settings/OrganizationSettings";
import ZonesBasic from "@/components/Zones/ZonesBasic";
import ZoneMap from "@/components/Zones/ZoneMap";
import MyZones from "@/components/Zones/MyZones";
import AddEditZone from "@/components/Zones/AddEditZone";
import ZoneManagement from "@/components/Zones/ZoneManagement";
import ZoneGeofenceHistory from "@/components/Zones/ZoneGeofenceHistory";
import UsersList from "@/components/Users/UsersList";
import LocationHistory from "@/components/Users/LocationHistory";
import ZoneEditBasic from "@/components/Zones/ZoneEditBasic";
import CircleHistory from "@/components/Circles/CircleHistory";
import CircleEditBasic from "@/components/Circles/CircleEditBasic";
import SubscriptionExpired from "@/components/SubscriptionExpired/SubscriptionExpired.vue";
import SubscriptionList from "@/components/Subscription/SubscriptionList.vue";
import AlertBasic from "@/components/Alert/AlertBasic.vue";
import AlertHistory from "@/components/Alert/AlertHistory.vue";
import AlertScheduled from "@/components/Alert/AlertScheduled.vue";
import MyOrganizations from "@/components/Settings/MyOrganizations.vue";
import NotificationsAndAlerts from "@/components/Settings/NotificationsAndAlerts.vue";
import EmailTemplates from "@/components/Settings/EmailTemplates.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {
            requiresAuth: false,
        }
    },
    {
        path: '/create-subscription',
        name: 'registration',
        component: RegistrationPage,
    },

    {
        path: '/organization-registration/:token',
        name: 'invitedRegistration',
        component: RegistrationPage,
    },
    {
        path: '/confirm-account/:token',
        name: 'confirmAccount',
        component: ConfirmAccount,
    },
    {
        path: '/organization-invitation/:token',
        name: 'organizationInvitation',
        component: AcceptOrganizationInvitation,
    },
    {
        path: '/create-subscription/:id/payment',
        name: 'registrationPayment',
        component: RegistrationPaymentPage,
        meta: {
            requiresAuth: false,
        }
    },
    {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: ForgotPasswordPage,
    },
    {
        path: '/forgot-password/:token',
        name: 'resetPassword',
        component: ResetPasswordPage,
    },
    {
        path: '/',
        component: CirclesPage,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: '',
                name: 'circleMap',
                component: CircleMap,
                meta: {
                    requiresAuth: true,
                    label: 'menu.circles',
                    subscriptionNeeded: true,
                }
            },

            {
                path: '/circles/my-circles',
                name: 'myCircles',
                component: MyCircles,
                meta: {
                    requiresAuth: true,
                    subscriptionNeeded: true,
                    label: 'menu.circles'
                }
            },
        ]
    },
    {
        path: '/circle/:id/add-members',
        component: CircleAddMembers,
        name: 'circleMemberAdd',
        meta: {
            requiresAuth: true,
            subscriptionNeeded: true,
        }
    },
    {
        path: '/circle/:id',
        component: CircleEditBasic,
        meta: {
            requiresAuth: true,
            subscriptionNeeded: true,
        },
        redirect: to => ({name: 'circleEdit', params: {id: to.params.id}}),
        children: [
            {
                path: 'edit',
                name: 'circleEdit',
                component: CircleEdit,
                meta: {
                    requiresAuth: true,
                    subscriptionNeeded: true,
                    subChildren: true,
                }
            },
            {
                path: 'history',
                name: 'circleHistory',
                component: CircleHistory,
                meta: {
                    requiresAuth: true,
                    subscriptionNeeded: true,
                    subChildren: true,
                }
            },
        ]
    },
    {
        path: '/notifications/',
        component: NotificationBasic,
        meta: {
            requiresAuth: true,
            subscriptionNeeded: true,
        },
        children: [
            {
                path: 'send',
                name: 'sendNotifications',
                component: NotificationSender,
                meta: {
                    requiresAuth: true,
                    label: 'menu.notifications',
                    subscriptionNeeded: true,
                    onlyAdmin: true,
                },
                props: true
            },
            {
                path: 'history',
                name: 'notificationHistory',
                component: NotificationHistory,
                meta: {
                    requiresAuth: true,
                    label: 'menu.notifications',
                }
            },
        ]
    },
    {
        path: 'notifications-history',
        name: 'notificationHistory',
        component: NotificationHistory,
        meta: {
            requiresAuth: true,
            label: 'menu.notifications',
            subscriptionNeeded: true,
        }
    },
    {
        path: '/alerts/',
        component: AlertBasic,
        meta: {
            requiresAuth: true,
            subscriptionNeeded: true,
        },
        children: [
            {
                path: '',
                name: 'alertHistory',
                component: AlertHistory,
                meta: {
                    requiresAuth: true,
                    label: 'menu.alerts',
                    subscriptionNeeded: true,
                },
                props: true
            },
            {
                path: 'scheduled-alerts',
                name: 'scheduledAlerts',
                component: AlertScheduled,
                meta: {
                    requiresAuth: true,
                    label: 'menu.alerts',
                    subscriptionNeeded: true,
                }
            },
        ]
    },
    {
        path: '/account',
        component: MyAccount,
        name: 'myAccount',
        meta: {
            requiresAuth: true,
            label: 'menu.account'
        }
    },
    {
        path: '/settings/',
        component: OrganizationSettings,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: 'my-subscription',
                name: 'subscriptionSettings',
                component: MyOrganizations,
                meta: {
                    requiresAuth: true,
                    label: 'menu.settings',
                    onlyAdmin: true,
                    subscriptionNeeded: true,
                }
            },
            {
                path: 'notifications-and-alerts',
                name: 'notificationsAndAlerts',
                component: NotificationsAndAlerts,
                meta: {
                    requiresAuth: true,
                    label: 'menu.settings',
                    subscriptionNeeded: true,
                }
            },
            {
                path: 'email-templates',
                name: 'emailTemplates',
                component: EmailTemplates,
                meta: {
                    requiresAuth: true,
                    label: 'menu.zones',
                    subscriptionNeeded: true,
                }
            },

        ]
    },
    {
        path: '/zones',
        component: ZonesBasic,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: '',
                name: 'zoneMap',
                component: ZoneMap,
                meta: {
                    requiresAuth: true,
                    label: 'menu.zones',
                    subChildren: true,
                    subscriptionNeeded: true,
                }
            },
            {
                path: 'my-zones',
                name: 'myZones',
                component: MyZones,
                meta: {
                    requiresAuth: true,
                    label: 'menu.zones',
                    subscriptionNeeded: true,
                }
            },

        ]
    },
    {
        path: '/zones/add-zone',
        component: ZoneEditBasic,
        meta: {
            requiresAuth: true,
            label: 'tooltips.addZone',
            subscriptionNeeded: true,

            subChildren: true,
        },
        children: [
            {
                name: 'addZone',
                path: '',
                component: AddEditZone,
                meta: {
                    onlyAdmin: true,
                    requiresAuth: true,
                    subChildren: true,
                    subscriptionNeeded: true,
                }
            }]
    },
    {
        path: '/zones/edit/:id/',
        component: ZoneEditBasic,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
        children: [
            {
                name: 'editZone',
                path: '',
                component: AddEditZone,
                meta: {
                    onlyAdmin: true,
                    requiresAuth: true,
                    subChildren: true,
                    subscriptionNeeded: true,
                }
            },
            {
                name: 'zoneManagement',
                path: 'management',
                component: ZoneManagement,
                meta: {
                    subChildren: true,
                    requiresAuth: true,
                    onlyAdmin: true,
                    subscriptionNeeded: true,
                }
            },
            {
                name: 'geofenceHistory',
                path: 'geofence-history',
                component: ZoneGeofenceHistory,
                meta: {
                    subChildren: true,
                    requiresAuth: true,
                    onlyAdmin: true,
                    subscriptionNeeded: true,
                }
            },
        ]
    },
    {
        path: '/users',
        component: UsersList,
        name: 'users',
        meta: {
            requiresAuth: true,
            label: 'notifications.users',
            onlyAdmin: true,
            subscriptionNeeded: true,

        }
    },
    {
        path: '/users/:id/location-history',
        component: LocationHistory,
        name: 'locationHistory',
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
            subscriptionNeeded: true,
        }
    },
    {
        path: '/subscription-expired',
        component: SubscriptionExpired,
        name: 'subscriptionExpired',
        meta: {
            requiresAuth: true,
            subscriptionNeeded: false,
        }
    },
    {
        path: '/subscriptions',
        component: SubscriptionList,
        name: 'subscriptions',
        meta: {
            requiresAuth: true,
            label: 'account.subscriptions'
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async function (to, from, next) {
    if ((to.meta.requiresAuth && !store.getters.isAuthenticated)) {
        next('/login');
    } else if (to.meta.requiresAuth === false && store.getters.isAuthenticated) {
        next('/');
    } else {
        if ((store.getters.selectedOrganization.IsSubscriptionExpired || !store.getters.hasActiveOrganization) && to.meta.subscriptionNeeded) {
            next('/subscription-expired')
        }

        if ((to.meta.onlyAdmin && !store.getters.isOrganizationAdmin) || (to.name === 'subscriptionExpired' && !from.name)) {
            next('/');
        }
        next();
    }
    window.scrollTo(0, 0);
});

export default router;
